import { PlusOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Space } from "antd";
import { observer } from "mobx-react-lite";

import Page from "@/ui/_common_/page";
import RubricatorSelector from "@/ui/_common_/rubricator-selector";

import { EditCategoryModal } from "./edit";
import { CategoryGamesModal } from "./games";
import { NewCategoryModal } from "./new";
import { RubricatorPageState } from "./page.state";
import { RubricatorTable } from "./table";

type Props = { state: RubricatorPageState };

export const RubricatorPageView = observer<Props>(({ state }) => {
  return (
    <Page title={"Rubricator"}>
      <NewCategoryModal />
      <EditCategoryModal />
      <CategoryGamesModal />
      <Card size="small">
        <Space direction="vertical">
          <Row justify="space-between" align="middle" gutter={[12, 12]}>
            <Col xs={24} md={8} lg={6} xl={4}>
              <RubricatorSelector style={{ width: "100%" }} />
            </Col>

            <Col>
              <Button
                icon={<PlusOutlined />}
                onClick={() => state.openNewCategoryModal(null)}
              >
                {"Create"}
              </Button>
            </Col>
          </Row>
          <RubricatorTable />
        </Space>
      </Card>
    </Page>
  );
});
